import "./Portfolio.css";
import PortfolioData from "./PortfolioData";

export default function Portfolio() {
  return (
    <section className="services section" id="portfolio">
      <h2 className="section__title">Portfolio</h2>
      <span className="section__subtitle">Projects I have made</span>

      <div className="services__container container grid">
        {/* <PortfolioData
          projectName="WorkPlanX"
          link="https://apps.apple.com/us/app/workplanx-hub/id6749725168?uo=4"
          iconClass="uil uil-apps services__icon"
        /> */}
        <PortfolioData
          projectName="DLSurf: Storage & Monetization"
          link="https://apps.apple.com/us/app/dlsurf-storage-monetization/id6751890136"
          iconClass="uil uil-apps services__icon"
        />
        <PortfolioData
          projectName="flutter_fake_filler (Flutter package)"
          link="https://pub.dev/packages/flutter_fake_filler"
          iconClass="uil uil-apps services__icon"
        />
        <PortfolioData
          projectName="Civil Hero Mobile App (Flutter)"
          link="https://civilhero.unvrit.com/"
          iconClass="uil uil-apps services__icon"
        />
        <PortfolioData
          projectName="Brother's Portfolio"
          link="https://www.sajanadhikari.com.np/"
          iconClass="uil uil-browser services__icon"
        />
        <PortfolioData
          projectName="Friend's Portfolio"
          link="https://ashishsubedi.com.np/"
          iconClass="uil uil-browser services__icon"
        />
      </div>
    </section>
  );
}
